import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';
import { CssSelectors, Layouts } from '../../../styles/styles';

// Mirrors the EditCampaign shell so the AI flow reads as the same send flow.
const contextContainerWidth = 360;
const columnSpacing = 30;

export const styleSheet = StyleSheet.create({
	briefCard: {
		background: THEME.colors.background.light,
		border: `1px solid ${THEME.colors.border.main}`,
		borderRadius: THEME.common.borderRadius,
		boxSizing: 'border-box',
		flexGrow: 1,
		maxHeight: '100%',
		overflowY: 'auto',
		width: '100%',
	},
	container: {
		height: '100%',
		position: 'relative',
		...Layouts.horizontalStack(columnSpacing),
	},
	contextContainer: {
		boxSizing: 'border-box',
		flexShrink: 0,
		height: '100%',
		overflow: 'hidden',
		paddingBottom: 20,
		paddingRight: 20,
		paddingTop: 20,
		width: contextContainerWidth,
		...CssSelectors.allChildren({
			height: '100%',
		}),
	},
	sendFromRow: {
		background: THEME.colors.background.light,
		border: `1px solid ${THEME.colors.border.main}`,
		borderRadius: THEME.common.borderRadius,
		boxSizing: 'border-box',
		flexShrink: 0,
		marginBottom: THEME.spacing.md,
		padding: THEME.spacing.md,
		width: '100%',
	},
	recipientsContainer: {
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
	},
	recipientsList: {
		flex: 1,
		minHeight: 0,
		minWidth: '100%',
		overflow: 'auto',
	},
	leftContainer: {
		boxSizing: 'border-box',
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
		paddingBottom: 20,
		paddingLeft: 20,
		paddingTop: 20,
		width: `calc(100% - ${contextContainerWidth + columnSpacing}px)`,
	},
	sendOptionsContainer: {
		height: '100%',
		overflowY: 'auto',
		width: '100%',
	},
});
